import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "bgColor", "withTransparentHeader", "noFixedMinHeightForHeader", "showOsanoDialog", "hideJoinButton", "showSignInOnBanner", "hideGiftBanner"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Header as BasicHeader } from '@store/components/Header';
import MainLayout from './MainLayout';
import { PAGE_HOW_IT_WORKS, PAGE_THINGS_WE_DO, PAGE_WHAT_YOU_GET, PAGE_PRICING, PAGE_CHECKOUT_PLAN, PAGE_LOGIN_ERROR, PAGE_EMPLOYERS, PAGE_FAQ } from '@store/constants/routes';
import { useOsano } from '@store/hooks/useOsano';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
var NAV_LINKS = [{
  title: 'header.nav.how-it-works',
  href: PAGE_HOW_IT_WORKS
}, {
  title: 'header.nav.what-you-get',
  href: PAGE_WHAT_YOU_GET
}, {
  title: 'header.nav.things-we-do',
  href: PAGE_THINGS_WE_DO
}, {
  title: 'header.nav.pricing',
  href: PAGE_PRICING
}, {
  title: 'header.nav.corporate-wellness',
  href: PAGE_EMPLOYERS
}]; // the in-page links will have to match nav-ids set in prismic

var NAV_LINKS_V2 = [{
  title: 'header.nav.things-we-do',
  href: '/#things-we-do'
}, {
  title: 'header.nav.pricing',
  href: '/#pricing'
}, {
  title: 'header.nav.how-it-works',
  href: '/#how-it-works'
}, {
  title: 'header.nav.faq',
  href: PAGE_FAQ
}, {
  title: 'header.nav.corporate-wellness',
  href: PAGE_EMPLOYERS
}];
var HIDE_LINKS_ON_ROUTES = [PAGE_CHECKOUT_PLAN, PAGE_LOGIN_ERROR];
/**
 * Primary layout component most marketing pages will be wrapped in.
 */

export var MarketingLayout = function MarketingLayout(_ref) {
  var children = _ref.children,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? 'base000' : _ref$bgColor,
      _ref$withTransparentH = _ref.withTransparentHeader,
      withTransparentHeader = _ref$withTransparentH === void 0 ? true : _ref$withTransparentH,
      _ref$noFixedMinHeight = _ref.noFixedMinHeightForHeader,
      noFixedMinHeightForHeader = _ref$noFixedMinHeight === void 0 ? true : _ref$noFixedMinHeight,
      _ref$showOsanoDialog = _ref.showOsanoDialog,
      showOsanoDialog = _ref$showOsanoDialog === void 0 ? false : _ref$showOsanoDialog,
      _ref$hideJoinButton = _ref.hideJoinButton,
      hideJoinButton = _ref$hideJoinButton === void 0 ? false : _ref$hideJoinButton,
      _ref$showSignInOnBann = _ref.showSignInOnBanner,
      showSignInOnBanner = _ref$showSignInOnBann === void 0 ? false : _ref$showSignInOnBann,
      _ref$hideGiftBanner = _ref.hideGiftBanner,
      hideGiftBanner = _ref$hideGiftBanner === void 0 ? false : _ref$hideGiftBanner,
      rest = _objectWithoutProperties(_ref, _excluded);

  // Consent management
  useOsano(showOsanoDialog);

  var _useExternalConfig = useExternalConfig(),
      _useExternalConfig$gl = _useExternalConfig.globalFeatures,
      enableWebsiteRefresh = _useExternalConfig$gl.enableWebsiteRefresh,
      enableRemovalSignUpYohanaUs = _useExternalConfig$gl.enableRemovalSignUpYohanaUs;

  var baseLinks = enableWebsiteRefresh ? NAV_LINKS_V2 : NAV_LINKS;
  var filteredLinks = enableRemovalSignUpYohanaUs ? baseLinks.filter(function (link) {
    return !['/#pricing', '/pricing', '/employers'].includes(link.href);
  }) : baseLinks;
  var shouldHideJoinButton = hideJoinButton || enableRemovalSignUpYohanaUs;
  return /*#__PURE__*/_jsx(MainLayout, _objectSpread(_objectSpread({}, rest), {}, {
    bgColor: bgColor,
    withTransparentHeader: withTransparentHeader,
    noFixedMinHeightForHeader: noFixedMinHeightForHeader,
    Header: /*#__PURE__*/_jsx(BasicHeader, {
      navLinks: filteredLinks,
      hideLinksOnRoutes: HIDE_LINKS_ON_ROUTES,
      showEmptySpace: !withTransparentHeader,
      hideJoinButton: shouldHideJoinButton,
      showSignInOnBanner: showSignInOnBanner,
      hideGiftBanner: hideGiftBanner
    }),
    websiteRefreshEnabled: enableWebsiteRefresh,
    children: children
  }));
};
export var getMarketingLayout = function getMarketingLayout(page, props) {
  return /*#__PURE__*/_jsx(MarketingLayout, _objectSpread(_objectSpread({}, props), {}, {
    children: page
  }));
};